﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const form_controls_1 = require("@its-suite/form-controls");
const app_commons_1 = require("@its-suite/app-commons");
const FormFieldDefinition_1 = require("./FormFieldDefinition");
const Utils_1 = require("../../Utils");
const styles = require("./ExtendedFields.scss");
const prefixId = Utils_1.PrefixId.GenericFormHelpers;
function generateField(item, fieldValue, callbackChanges) {
    let formElement;
    switch (item.type) {
        case FormFieldDefinition_1.FormFieldType.Text:
            formElement = generateTextInput(item, fieldValue, callbackChanges);
            break;
        case FormFieldDefinition_1.FormFieldType.Boolean:
            formElement = generateSwitch(item, fieldValue, callbackChanges);
            break;
        case FormFieldDefinition_1.FormFieldType.DateTime:
            formElement = generateDatePicker(item, fieldValue, callbackChanges);
            break;
        case FormFieldDefinition_1.FormFieldType.Select:
            formElement = generateSelect(item, fieldValue, callbackChanges);
            break;
    }
    return (React.createElement("div", { key: 'formItem_' + item.name }, formElement));
}
exports.generateField = generateField;
function generateTextInput(item, fieldValue, callbackChanges) {
    let onChange = (event) => {
        handleValueChange(event.currentTarget.value, item.name, callbackChanges);
    };
    return (React.createElement(form_controls_1.TextField, { key: 'input_' + item.name, className: styles.formControl, name: item.name, label: item.visibleName, onChange: onChange, value: fieldValue || '', type: 'text', autoComplete: 'off', validators: item.validatorList, disabled: item.disabled, id: form_controls_1.IdentifierHelpers.createId(prefixId, form_controls_1.IdentifierHelpers.IdForElement.TextField, [item.name]) }));
}
function generateSwitch(item, fieldValue, callbackChanges) {
    let onChange = (event, checked) => {
        handleValueChange(checked, item.name, callbackChanges);
    };
    return (React.createElement(form_controls_1.Switch, { checked: fieldValue || false, name: item.name, label: item.visibleName, disabled: item.disabled, id: form_controls_1.IdentifierHelpers.createId(prefixId, form_controls_1.IdentifierHelpers.IdForElement.Switch, [item.name]), onChange: onChange }));
}
function generateDatePicker(item, fieldValue, callbackChanges) {
    let onChange = (date) => {
        handleValueChange(date, item.name, callbackChanges);
    };
    return (React.createElement(app_commons_1.DatePickerContainer, { key: 'datePicker_' + item.name, className: styles.formControl, name: item.name, label: item.visibleName, onChange: onChange, value: fieldValue || null, disabled: item.disabled, id: form_controls_1.IdentifierHelpers.createId(prefixId, form_controls_1.IdentifierHelpers.IdForElement.DatePicker, [item.name]) }));
}
function generateSelect(item, fieldValue, callbackChanges) {
    let onChange = (event) => {
        handleValueChange(event.target.value, item.name, callbackChanges);
    };
    return (React.createElement(form_controls_1.Select, { className: styles.formControl, name: item.name, key: 'sf_' + item.name, label: item.visibleName, value: fieldValue, onChange: onChange, validators: item.validatorList, items: generateSelectItems(item.selectOptions), disabled: item.disabled, id: form_controls_1.IdentifierHelpers.createId(prefixId, form_controls_1.IdentifierHelpers.IdForElement.Select, [item.name]) }));
}
function generateSelectItems(items) {
    return items
        .map(item => ({ value: item, text: item }))
        .sort((a, b) => form_controls_1.StringHelpers.compareStringsOrNumber(a.text, b.text));
}
function handleValueChange(value, name, callback) {
    callback(name, value);
}
//# sourceMappingURL=GenericFormHelpers.js.map